import request from '@/util/request';
import qs from 'qs';


export const getDetail = (params, options) =>
  request.get('/api/v4ward/park/settings/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/v4ward/park/settings/remove/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/park/settings/submit/v2', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/park/settings/update/v2', params, options);

export const sync = (params, options) =>
  request.post('/api/v4ward/park/settings/sync/v2', params, options);

//获取商家列表
export const shopSelections = (params, options) =>
  request.get('/api/client/park/coupon/shop/shopSelections/v2', Object.assign({}, options, {
    params
  }));
//获取商家自制券
export const getIssueList = (params, options) =>
  request.get('/api/client/park/coupon/issue/getIssueList/v2', Object.assign({}, options, {
    params
  }));

//获取所有支付方式
export const spaceBasePayType = (params, options) =>
  request.get('/api/v4ward/park/settings/spaceBasePayType/v2', Object.assign({}, options, {
    params
  }));
